import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { PeronosporaPrediction } from "../models";
import { AxiosResponse } from 'axios'

export default class UnifiWidgetsAPI {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getData(pk_cuaa: number, lot_id: number): Promise<{ error: string; data: PeronosporaPrediction | null }>
    {
        const linkedStationId = await this.getIdFromLinkedStation(pk_cuaa, lot_id)

        if (linkedStationId == "no-linked-stations") {
            return { data: null, error: "no-linked-stations" }
        }

        let response: AxiosResponse | null = null;

        try {
            response = await this.http.get(`/api/v1.0/pdm/grapevine/peronospora/${pk_cuaa}/${linkedStationId}`)
        }

        catch(e)
        {
            return { error: 'no-needed-sensors', data: null }
        }

        return { error: '', data: response.data }
    }

    private async getIdFromLinkedStation(farmId: number, lotId: number): Promise<string> {
        const res = await this.http.get(`/iot/api/v1/farm/${farmId}/plots/${lotId}/stations`)

        return (res.status == 200 && res.data?.length > 0) ? res.data[0] : "no-linked-stations"
    }
}
